import { FC, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { ISimilarItemsPageProps } from './types';

import { ItemsWithoutFiltersWithId } from '../../components';

import { PageWrapperWithCommonBlocks } from 'src/components';
import { removeCurrentData, saveCurrentPaginationPage } from 'src/models';
import { getSimilarItems } from '~utils';

export const SimilarItemsPage: FC<ISimilarItemsPageProps> = ({ className = '', ...rest }) => {
  const { t } = useTranslation();

  useEffect(() => {
    removeCurrentData();
    saveCurrentPaginationPage(1);
  }, []);

  return (
    <PageWrapperWithCommonBlocks className={className} {...rest}>
      <ItemsWithoutFiltersWithId title={t('items.similar-items-title')} fetchFn={getSimilarItems} />
    </PageWrapperWithCommonBlocks>
  );
};
